import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { Scrollable } from './Scrollable';

export type PaddedScrollableProps = ComponentProps<'div'> & {
  fullHeight?: boolean;
  fullWidth?: boolean;
  innerClassName?: string;
  className?: string;
};

export function PaddedScrollable({
  children,
  id,
  fullHeight,
  fullWidth,
  ref,
  className,
  innerClassName,
}: PaddedScrollableProps) {
  const _innerClassName = cn('flex flex-col px-8 py-2.5', innerClassName, {
    'min-h-full': fullHeight,
    'min-w-full flex-row w-auto': fullWidth,
  });
  return (
    <Scrollable ref={ref} id={id} className={className} innerClassName={_innerClassName}>
      {children}
    </Scrollable>
  );
}

export function SmallPaddedScrollable({
  children,
  id,
  fullHeight,
  fullWidth,
  innerClassName,
  className,
  ref,
}: PaddedScrollableProps) {
  const _innerClassName = cn('flex w-full flex-col p-4 py-2.5', innerClassName, {
    'min-h-full': fullHeight,
    'min-w-full flex-row w-auto': fullWidth,
  });

  return (
    <Scrollable ref={ref} id={id} className={className} innerClassName={_innerClassName}>
      {children}
    </Scrollable>
  );
}

export const Padded = ({ fullHeight, className, ...props }: PaddedScrollableProps) => {
  return <div className={cn('flex flex-col px-8 py-2.5', { 'min-h-full': fullHeight }, className)} {...props} />;
};

export const SmallPadded = ({ fullHeight, className, ...props }: PaddedScrollableProps) => {
  return <div className={cn('flex w-full flex-col p-4 py-2.5', { 'min-h-full': fullHeight }, className)} {...props} />;
};
